import { API } from 'aws-amplify';
import { MDBCard, MDBCardBody, MDBCardTitle, MDBCol, MDBDatePickerV5, MDBDatePicker, MDBRow, MDBSelectV5,MDBTable, MDBTableBody } from 'mdbreact'
import React, { useEffect, useState } from 'react'
import { Line, Pie  } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
import "./Dashboard.css"
import images from "../components/images"

import moment from 'moment';




export default function Dashboard() {
  const { t, i18n } = useTranslation();
  const [data, setData] = useState({})
  const [hasData, setHasData] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
 
  const nowTime = new Date()
  const nowTimeZero = new Date(nowTime.setHours(0,0,0,0))
  const [filter, setFilter] = useState({
    toDate: nowTime.toISOString(),
    fromDate: new Date(new Date().setDate(nowTimeZero.getDate()-30)).toISOString(),
    chartXType: "days"
  })

  useEffect(() => {
      const getData = async () => { 
        setIsLoading(true)
        try {
          const res = await API.post("ConnectApi", "statistics/dashboard", { body: {
            fromDate: filter.fromDate,
            toDate: filter.toDate,
            chartXType: filter.chartXType
          }})
          setData(res)
          setHasData(true)
          setIsLoading(false)
        } catch (error) {
          setIsLoading(false)
        } 
      }
      if(!isLoading){
        getData()
      }
  }, [filter.fromDate, filter.toDate])

  return (
    <div>
    <MDBRow>
    <MDBCol size="6"></MDBCol>
      <MDBCol size="6">
        {/* <MDBSelectV5
        className="float-left select_marketplace"
        options={[
          {
            value: "0",
            text: "Marketplace",
            disabled: true
          },
          {
            icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4a/Amazon_icon.svg/240px-Amazon_icon.svg.png",
            value: "2",
            text: "Amazon" 
          },
          {
            icon: "data:image/png;base64,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",
            value: "2",
            text: "eBay" 
          },
          {
            icon: "data:image/png;base64,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",
            value: "2",
            text: "Shopify" 
          }, {
            icon: "https://cdn.iconscout.com/icon/free/png-256/shopware-3521706-2945150.png",
            value: "2",
            text: "Shopware" 
          }
        ]}
        selected="Marketplace"
        /> */}
        <MDBDatePicker locale={moment.locale(i18n.language)} className="float-right mt-0 mx-2 date-select-label-sm" theme={datePickerTheme} label={t("filter.toDate", "To Date")} valueDefault={new Date(filter.toDate)} getValue={(e)=> setFilter({...filter, toDate: new Date(e.setHours(23,59,59,999)).toISOString()})} />
        <MDBDatePicker className="float-right mt-0 mx-2 date-select-label-sm" theme={datePickerTheme} label={t("filter.fromDate", "From Date")} valueDefault={new Date(filter.fromDate)} getValue={(e)=> setFilter({...filter, fromDate: new Date(e.setHours(0,0,0,0)).toISOString()})} />
        
      </MDBCol>
    <MDBCol>
      
    </MDBCol>
  </MDBRow>
  {isLoading ? 
      <div className="w-100 text-center">
        <div className="spinner-grow text-default" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div> 
    :
    hasData && (data.chartArray) ? 
      <>
      <MDBRow>
      <MDBCol>
        <MDBCard>
          <MDBCardBody>
            <MDBCardTitle>{t("sales", "Sales")}</MDBCardTitle>
            {isLoading ? 
            <div className="w-100 text-center">
              <div className="spinner-grow text-default" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div> 
            :
            <MDBRow>
              <MDBCol size="12" md="4">
                <MDBCard style={{boxShadow: "none"}}>
                  <MDBCardBody>
                    <MDBCardTitle>{t("money.total", "Total")}</MDBCardTitle>
                    <MDBTable>
                      <MDBTableBody>
                        <tr>
                          <td>{t("money.revenue", "Revenue")}</td>
                          <td>{data.revenue + "€" ||""}</td>
                        </tr>
                        <tr>
                          <td>{t("gen.orders", "Orders")}</td>
                          <td>{data.totalOrders ||""}</td>
                        </tr>
                        <tr>
                          <td>{t("dashboard.productsSold", "Products sold")}</td>
                          <td>{data.items ||""}</td>
                        </tr>
                        <tr>
                          <td>{t("dashboard.averageOValue", "Average order value")}</td>
                          <td>{data.averageRevenue + "€" ||""}</td>
                        </tr>
                      </MDBTableBody>
                    </MDBTable>
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>
              <MDBCol size="12" md="8">
              {hasData && data.chartArray && 
                <Line data={{
                  labels: data.chartArray.map(i => i.name),
                  datasets: [
                    {
                      label: "Sales",
                      fill: true,
                      lineTension: 0.3,
                      backgroundColor: "rgb(0 150 136 / 25%)",
                      borderColor: "rgb(0 150 136)",
                      borderCapStyle: "butt",
                      borderDash: [],
                      borderDashOffset: 0.0,
                      borderJoinStyle: "miter",
                      pointBorderColor: "rgb(205, 130,1 58)",
                      pointBackgroundColor: "rgb(255, 255, 255)",
                      pointBorderWidth: 10,
                      pointHoverRadius: 5,
                      pointHoverBackgroundColor: "rgb(0, 0, 0)",
                      pointHoverBorderColor: "rgba(220, 220, 220,1)",
                      pointHoverBorderWidth: 2,
                      pointRadius: 1,
                      pointHitRadius: 10,
                      data: data.chartArray.map(i => i.value)
                    }
                  ]
                }} options={{ responsive: true }} />
              }
              </MDBCol>
            </MDBRow>
            }
            
          </MDBCardBody>
        </MDBCard>
      </MDBCol>
    </MDBRow>
    <MDBRow className="mt-4">
    <MDBCol size="12" md="3">
      <MDBCard style={{height: "100%"}}>
        <MDBCardBody>
          <MDBCardTitle>{t("gen.Realtime", "Realtime")}</MDBCardTitle>
          <MDBTable>
            {isLoading ?
            <div className="w-100 text-center">
              <div className="spinner-grow text-default" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div> 
            :
            hasData && <MDBTableBody>
              <tr>
                <td>{t("gen.inFulfillment", "Processing shipment")}</td>
                <td>{data.counts.instructed}</td>
              </tr>
              <tr className={data.counts.verify > 0 ? "rgba-red-light" : ""}>
                <td>{t("dashboard.problems", "With Problems")}</td>
                <td>{data.counts.verify}</td>
              </tr>
              <tr>
                <td>{t("gen.openShippment", "Open Shippment")}</td>
                <td>{data.counts.unshipped}</td>
              </tr>
            </MDBTableBody>
            }
          </MDBTable>
        </MDBCardBody>
      </MDBCard>
    </MDBCol>
      <MDBCol size="12" md="9">
        <MDBCard>
          <MDBCardBody>
            <MDBCardTitle>{t("gen.fulfillment", "Fulfillment")}</MDBCardTitle>
            <MDBRow>
              <MDBCol size="12" md="5">
                <MDBCard style={{boxShadow: "none"}}>
                  <MDBCardBody>
                    <MDBCardTitle>{t("gen.shippingProviders", "Shipping Providers")}</MDBCardTitle>
                    <MDBTable>
                      <MDBTableBody>
                      {isLoading ?
                        <div className="w-100 text-center">
                          <div className="spinner-grow text-default" role="status">
                            <span className="sr-only">Loading...</span>
                          </div>
                        </div>
                      :
                       hasData && data.shippingProviderOrders &&  data.shippingProviderOrders.map(sp => <tr>
                          <td>{images[sp.handler]}</td>
                          <td>{sp.value}</td>
                        </tr>)}
                      </MDBTableBody>
                    </MDBTable>
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>
              <MDBCol size="12" md="7">
              {isLoading ?
              <div className="w-100 text-center">
                <div className="spinner-grow text-default" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
              :
              hasData && data.countryOrders && <Pie data={{
                  labels: data.countryOrders.map(cO => cO.iso),
                  datasets: [
                    {
                      data: data.countryOrders.map(cO => cO.value),
                      backgroundColor: [
                        "#46BFBD",
                        "#F7464A",
                        "#FDB45C",
                        "#4D5360",
                        "#AC64AD",
                        "#F7464A",
                        "#46BFBD",
                        "#FDB45C",
                        "#949FB1",
                        "#4D5360",
                      ],
                      hoverBackgroundColor: [
                        "#5AD3D1",
                        "#FF5A5E",
                        "#FFC870",
                        "#616774",
                        "#DA92DB",
                        "#FF5A5E",
                        "#5AD3D1",
                        "#FFC870",
                        "#A8B3C5",
                        "#616774",
  
                      ]
                    }
                  ]
                }} options={{ responsive: true }} />
              }

              </MDBCol>
            </MDBRow>
          </MDBCardBody>
        </MDBCard>
      </MDBCol>
    </MDBRow>  
      </>
    :
    <MDBRow>
      <MDBCol size="12" md="4">
        <MDBCard style={{height: "100%"}}>
          <MDBCardBody>
            <MDBCardTitle>{t("gen.Realtime", "Realtime")}</MDBCardTitle>
            <MDBTable>
              {isLoading ?
              <div className="w-100 text-center">
                <div className="spinner-grow text-default" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div> 
              :
              hasData && <MDBTableBody>
                <tr>
                  <td>{t("gen.inFulfillment", "Processing shipment")}</td>
                  <td>{data.counts.instructed}</td>
                </tr>
                <tr className={data.counts.verify > 0 ? "rgba-red-light" : ""}>
                  <td>{t("dashboard.problems", "With Problems")}</td>
                  <td>{data.counts.verify}</td>
                </tr>
                <tr>
                  <td>{t("gen.openShippment", "Open Shippment")}</td>
                  <td>{data.counts.unshipped}</td>
                </tr>
              </MDBTableBody>
              }
            </MDBTable>
          </MDBCardBody>
        </MDBCard>
      </MDBCol>
      <MDBCol size="12" md="8">
      <div className="text-center w-100">
        <img className="rounded-0 mx-auto" src="https://s3.eu-central-1.amazonaws.com/cdn.eu.com/ch/illustration/Dashboard.png" alt="DHL" />
        <h6>Keine Daten im ausgewählten Zeitraum gefunden.</h6>
      </div>
      </MDBCol>
    </MDBRow>
    
    
    }
    
    </div>
  )
}

const datePickerTheme = {
  palette: {
    primary: {
      main: '#009688',
    }
  }
}
const chartData = {
  labels: ["January", "February", "March", "April", "May", "June", "July"],
  datasets: [
    {
      label: "Sales",
      fill: true,
      lineTension: 0.3,
      backgroundColor: "rgb(0 150 136 / 25%)",
      borderColor: "rgb(0 150 136)",
      borderCapStyle: "butt",
      borderDash: [],
      borderDashOffset: 0.0,
      borderJoinStyle: "miter",
      pointBorderColor: "rgb(205, 130,1 58)",
      pointBackgroundColor: "rgb(255, 255, 255)",
      pointBorderWidth: 10,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: "rgb(0, 0, 0)",
      pointHoverBorderColor: "rgba(220, 220, 220,1)",
      pointHoverBorderWidth: 2,
      pointRadius: 1,
      pointHitRadius: 10,
      data: [65, 59, 80, 81, 56, 55, 40]
    }
  ]
}

const pieData = {
  labels: ["Red", "Green", "Yellow", "Grey", "Dark Grey"],
  datasets: [
    {
      data: [300, 50, 100, 40, 120],
      backgroundColor: [
        "#F7464A",
        "#46BFBD",
        "#FDB45C",
        "#949FB1",
        "#4D5360",
        "#AC64AD"
      ],
      hoverBackgroundColor: [
        "#FF5A5E",
        "#5AD3D1",
        "#FFC870",
        "#A8B3C5",
        "#616774",
        "#DA92DB"
      ]
    }
  ]
}

